import { get } from 'lodash';

export const analyticsEventTransformer = eventData => {
    if (!eventData) {
        return eventData;
    }

    const flow = get(eventData, 'flow');

    if (!flow) {
        return eventData;
    }

    const { flow: _, ...eventDataWithoutFlow } = eventData;

    const firstAction = get(flow, 'actions[0]');

    if (!firstAction) {
        return eventDataWithoutFlow;
    }

    const methodName = get(firstAction, 'data.methodName');
    const args = get(firstAction, 'data.args');

    return {
        ...eventDataWithoutFlow,
        ...(methodName && { methodName }),
        ...(args && { methodArgs: args }),
    };
};
